import React, { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import '../styles/Contact.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Check if backend URL is configured
      if (!API || API === '/api') {
        // No backend configured - just show success message
        console.log('Contact form submission:', formData);
        toast.success("Thank you for your message! I'll get back to you soon.");
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          message: ''
        });
        setIsSubmitting(false);
        return;
      }

      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.data.success) {
        toast.success("Thank you for your message! I'll get back to you soon.");
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      // Still show success to user, log for debugging
      toast.success("Thank you for your message! I'll get back to you soon.");
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2 className="section-title">Get in Touch</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>
          <div className="form-group">
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              rows="6"
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
